export const VIEWPORT_MENU_PADDING = 12;
export const LISTING_CARD_MENU_MIN_WIDTH = 200;

/**
 * Viewport-fixed position for listing-card ⋮ menus.
 * Escapes carousel overflow, stays on-screen in LTR and RTL, and never
 * expands document width (left/width are clamped to the viewport).
 *
 * LTR: ⋮ is on the card's right — grow the menu left from the label.
 * RTL: ⋮ is on the card's left — grow the menu right from the label.
 */
export const getViewportMenuPosition = ({
  labelRect,
  contentWidth,
  viewportWidth,
  viewportHeight = 800,
  isRtl = false,
  padding = VIEWPORT_MENU_PADDING,
} = {}) => {
  const maxWidth = Math.max(padding * 2, viewportWidth - padding * 2);
  const width = Math.min(
    Math.max(Number(contentWidth) || LISTING_CARD_MENU_MIN_WIDTH, LISTING_CARD_MENU_MIN_WIDTH),
    maxWidth
  );

  const preferredLeft = isRtl
    ? labelRect?.left ?? padding
    : (labelRect?.right ?? width + padding) - width;

  const maxLeft = Math.max(padding, viewportWidth - padding - width);
  const left = Math.min(Math.max(preferredLeft, padding), maxLeft);

  const preferredTop = (labelRect?.bottom ?? 0) + 4;
  const maxTop = Math.max(padding, viewportHeight - padding);
  const top = Math.min(Math.max(preferredTop, padding), maxTop);

  return {
    position: 'fixed',
    top,
    left,
    width,
    right: 'auto',
    maxWidth,
  };
};

export const isDocumentRtl = (doc = typeof document !== 'undefined' ? document : null) => {
  if (!doc?.documentElement) {
    return false;
  }
  const html = doc.documentElement;
  return html.getAttribute('dir') === 'rtl' || html.getAttribute('lang') === 'ar';
};
